//Appends text with value passed as arguement
//Example: "0.7" with argument "%" returns "0.7%"
export default function appendStr(value, appendText) {
	return value || value === 0 ? `${value}${appendText}` : "";
}
